import React from "react";
import "../css/createTikTokDestination.css";
import { useSelector } from "react-redux";
import SwalAlertComp from "./SwalAlert";
import LoginButton from "./molecules/LoginButton";
import { getPinterestAuthUrl } from "../helpers/destinations/createDestination";

const PinterestAuthButton = ({ setAuthData, isLoading }) => {
    const language = useSelector((state) => state.languagesState.languages);

    const getAuthUrl = async () => {
        const response = await getPinterestAuthUrl();
        if (response?.status) {
            return response?.data?.url ?? null;
        }
        SwalAlertComp({
            title: language?.delete_swal_modal?.failed ?? "Failed",
            message: response?.message,
            icon: "error",
        });
        return null;
    };

    const handleSuccess = (data) => {
        if (setAuthData) {
            setAuthData(data);
        }
    };

    return (
        <LoginButton
            code="pinterest"
            getAuthUrl={getAuthUrl}
            paramNames={["code", "state"]}
            onSuccess={handleSuccess}
            dataTransform={(params) => ({
                code: params.code,
                state: params.state,
            })}
            logoSrc="/assets/images/typeImages/pinterest-icon.png"
            buttonText={
                language?.destination_modal?.reconnect_with_pinterest ??
                "Reconnect with Pinterest"
            }
            isLoadingExternal={isLoading}
        />
    );
};

export default PinterestAuthButton;
